import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { FormID } from '@finxone-platform/form-action';
import {
  ActionButtonOutcomesType,
  ActionButtonWidgetActionsOutcomesNavigationConfigMap,
  BaseWidgetProperties,
  ButtonActionType,
  actionButtonNavigationConfigType,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { parsePhoneNumber } from 'libphonenumber-js';
import { SetFormActionWithId } from '../../../actions/form-submission.action';
import { ProfileState } from '../../../state/user-profile.state';
import { redirectToPage } from '../cta-button-actions.utils';

export const editVerificationInformation = (widgetProperties: BaseWidgetProperties, injector: Injector) => {
  const router = injector.get(Router);
  const store = injector.get(Store);

  const navigationConfig = widgetProperties?.actionNavigationConfigurations;

  const profile = store.selectSnapshot(ProfileState.getProfile);
  const parsedPhone = parsePhoneNumber(profile?.phoneNumber || '');

  // build the payload for verification information, // needs to have same input field key name from the workflow
  const payload = {
    firstName: profile?.firstName,
    middleName: profile?.middleName,
    lastName: profile?.lastName,
    dob: profile?.dob,
    address1: profile?.address1,
    address2: profile?.address2,
    address3: profile?.address3,
    address4: profile?.address4,
    county: profile?.county,
    city: profile?.city,
    postalCode: profile?.postalCode,
    country: profile?.country,
    email: profile?.email,
    countryCode: parsedPhone?.countryCallingCode ? `+${parsedPhone.countryCallingCode}` : undefined,
    phoneNumber: parsedPhone?.nationalNumber,
    isEmailVerified: profile?.emailVerified,
    isPhoneVerified: profile?.phoneVerified,
    ...profile?.extraAttributes,
  };

  store.dispatch(new SetFormActionWithId({ formData: payload, type: '' }, FormID.VERIFICATION_FORM));

  const defaultNavigation = ActionButtonWidgetActionsOutcomesNavigationConfigMap.get(
    ButtonActionType.VERIFICATION_EDIT_INFORMATION,
  );

  const handleNavigation = (outcome: ActionButtonOutcomesType): void => {
    const config =
      navigationConfig?.[outcome] ?? (defaultNavigation as actionButtonNavigationConfigType)[outcome];
    const navigationProps: BaseWidgetProperties = {
      textContent: '',
      zoneToNavigate: config?.selectedZone,
      urlToNavigate: config?.selectedPageUrl,
    };

    redirectToPage(router, navigationProps, injector);
  };

  handleNavigation(ActionButtonOutcomesType.SUCCESS);
};
